import { CATEGORIES } from "@/data/menu";

const Star = ({ color }) => (
  <svg viewBox="0 0 24 24" className="mx-8 h-6 w-6 shrink-0 sm:mx-12 sm:h-8 sm:w-8" aria-hidden="true">
    <path d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12 7-1 11-5 12-12z" fill={color} />
  </svg>
);
const COLORS = ["#E11D48", "#F59E0B", "#F472B6", "#34D399", "#60A5FA"];

export const Marquee = () => {
  const row = CATEGORIES.map((c, i) => (
    <span key={c.id} className="flex items-center">
      <span className={`f-display whitespace-nowrap text-4xl sm:text-6xl ${i % 2 ? "italic" : ""}`}>{c.name}</span>
      <Star color={COLORS[i % COLORS.length]} />
    </span>
  ));
  return (
    <div className="overflow-hidden border-y border-[#2D1E18]/10 bg-blush py-7 text-cacao sm:py-9" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};
